import React from 'react';

export default function helpShortcut ({ target, children }) {
  return <span className="js-help">{ children }</span>;
}